import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'components/button';
import InputField from 'components/inputField';
import Select from 'components/reactSelect';
import CheckBox from 'components/checkbox/index';
import Dialog from 'components/dialog';
import { search } from './action';
class SampleIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openSampleDialog: false,
      isCheck: false
    };
    this.onSearch = this.onSearch.bind(this);
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    //收到props更新state
    console.log(nextProps);
    console.log(prevState);
    return null;
  }
  componentDidMount() {
    //set event listeners
    console.log(1);
  }
  getSnapshotBeforeUpdate(prevProps, prevState) {
    //render前，把值傳給componentDidUpdate
    console.log(prevProps);
    console.log(prevState);
    return null;
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    //DOM更新之後做什麼
    console.log(prevProps);
    console.log(prevState);
    console.log(snapshot);
  }
  componentWillUnmount() {
    //元件銷毀做什麼
  }
  onSearch() {
    const { props, refs } = this,
      { dispatch } = props,
      { text } = refs;
    dispatch(search({
      text: text.getValue()
    }));
  }
  render() {
    const self = this,
      {
        state,
      } = self,
      {
        openSampleDialog,
        isCheck
      } = state;
    return (
      <div>
        <div>
          {/* InputField */}
          <div>
            <div>↓ ↓ ↓ Input↓ ↓ ↓ </div>
            <InputField
              inputType='name'
              ref='text'
              placeholder={'Sample'}
              // validate={}
              // onBlur={}
              // value={}
              // defaultValue={}
              frameStyle={{ marginBottom: '10px', width: '100px' }}
            />
          </div>
          {/* Button */}
          <div>
            <div>↓ ↓ ↓ Button ↓ ↓ </div>
            <Button
              className={'primary-button'}
              onClick={()=>{
                this.setState({
                  openSampleDialog: true
                });
              }}
            >
              確定(show dialog)
            </Button>
            <Button
              className={'close-button'}
            >
              取消
            </Button>
            <Button
              className={'disabled-button'}
              disabled
            >
              無法操作
            </Button>
          </div>
          {/* Select */}
          <div>
            <div>↓ ↓ ↓ Select ↓ ↓ </div>
            <Select
              id={'sampleSelect'}
              ref={'sampleSelect'}
              onChangeEvent={(data) => {
                console.log(data)
              }}
              placeholder={'請選擇'}
              frameStyle={{ width: '500px' }}
              defaultValue={{
                "label": "台灣 - 所有機場",
                "value": "XX3"
              }}
              options={[
                {
                  "label": "日本",
                  "options": [
                    {
                      "label": "北海道地區 - 所有機場",
                      "value": "XX2"
                    },
                    {
                      "label": "旭川(AKJ)",
                      "value": "AKJ"
                    },
                    {
                      "label": "函館(HKD)",
                      "value": "HKD"
                    }
                  ]
                },
                {
                  "label": "台灣",
                  "options": [
                    {
                      "label": "台灣 - 所有機場",
                      "value": "XX3"
                    },
                    {
                      "label": "台北(桃園)(TPE)",
                      "value": "TPE"
                    },
                    {
                      "label": "台中(RMQ)",
                      "value": "RMQ"
                    },
                    {
                      "label": "高雄(KHH)",
                      "value": "KHH"
                    }
                  ]
                }
              ]}
              // options={},
              // styles = {},
              // frameStyle = {},
              // placeholder = {},
              // id = {},
              // defaultValue = {},
              // errorText = {},
              // errorTextStyle = {},
              // isDisabled = {}, //能不能輸入狀態
              // isSearchable = {}, //能不能搜尋
              // isClearable = {}, //有沒有清除的叉叉
              // isLoading = {}, //元件loading中
              // isRtl = {} 左右顛倒
            />
          </div>
          {/* Checkbox */}
          <div>
            <div>↓ ↓ ↓ Checkbox ↓ ↓ </div>
            <CheckBox
              id={'checkbox'}
              className={'checkbox'}
              value={isCheck}
              checked={isCheck}
              text={'sample'}
              onClick={() => {
                self.setState({
                  isCheck: !isCheck
                });
              }}
            />
          </div>
        </div>
        <Dialog
          dialogId='sampleDialog'
          maxWidth='xs' //'sm' 'md' 'lg' 'xl' false => 444px 960px 1280px 1920px disable
          zIndex={2000}
          open={!!openSampleDialog}
          title={'SampleDialog'}
          actionsClassName='sample-dialog'
          onConfirmClick={()=>{
            this.setState({
              openSampleDialog: false
            });
          }}
          onCloseClick={() => {
            this.setState({
              openSampleDialog: false
            });
          }}
          onRequestClose={() => {
            this.setState({
              openSampleDialog: false
            });
          }}
          // actions={}
        >
          <div>
            Sample Dialog
          </div>
        </Dialog>
      </div>
    );
  }
}

let mapStateToProps = (state) => {

  return {
    mainState: state.mainReducer,
  };
};

export default connect(mapStateToProps)(SampleIndex);